const COMPONENT_NAME = "z-fetch" ;


export default function register(){
    class FetchComponent extends HTMLElement {
        constructor() {
            super();
        }
    }
    customElements.define(COMPONENT_NAME, FetchComponent);
}
